import { useCallback, useEffect, useState } from 'react';
import { learnerApi } from '../services/learnerApi';

export function useSupervisors() {
  const [supervisors, setSupervisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await learnerApi.listSupervisors({});
      setSupervisors(Array.isArray(data?.supervisors) ? data.supervisors : []);
    } catch (e) {
      setError(e?.message || 'Failed to load supervisors.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const revoke = useCallback(async (supervisorId) => {
    await learnerApi.revokeSupervisor({ supervisorId });
    setSupervisors((prev) => prev.filter((s) => s.supervisorId !== supervisorId));
  }, []);

  return { supervisors, loading, error, reload: load, revoke };
}
